import { FACTOR_CENTIMETER_MILLIMETER } from '../../constants';
import { Alignment } from '../Alignment';
import {
  SingleSlotDefinition,
  SlotDefinition,
  SlotLineDefinition,
  SlotPairDefinition,
  SlotType,
} from '../SlotDefinition';

export class SlotDefinitionMapper {
  static toDomain = (dto: CoreServiceAPI.SlotDefinitionDto): SlotDefinition => {
    switch (dto.type) {
      case 'SINGLE':
        return {
          name: dto.name,
          type: SlotType.SINGLE,
          alignment: dto.alignment ? (dto.alignment as Alignment) : Alignment.NONE,

          xIndex: dto.xindex ?? undefined,
          yIndex: dto.yindex ?? undefined,
        } as SingleSlotDefinition;
      case 'LINE':
        return {
          name: dto.name,
          type: SlotType.LINE,
          length: dto.lineLength && dto.lineLength / FACTOR_CENTIMETER_MILLIMETER,
          axis: dto.axis,
        } as SlotLineDefinition;
      case 'PAIR':
        return {
          name: dto.name,
          type: SlotType.PAIR,
        } as SlotPairDefinition;
    }
  };

  static toDto = (slot: SlotDefinition): CoreServiceAPI.SlotDefinitionDto => ({
    name: slot.name,
    type: slot.type,
    alignment:
      slot.type === SlotType.SINGLE && slot.alignment !== Alignment.NONE
        ? slot.alignment
        : undefined,
    xindex: slot.type === SlotType.SINGLE ? slot.xIndex : undefined,
    yindex: slot.type === SlotType.SINGLE ? slot.yIndex : undefined,
    lineLength:
      slot.type === SlotType.LINE ? slot.length * FACTOR_CENTIMETER_MILLIMETER : undefined,
    axis: slot.type === SlotType.LINE ? slot.axis : undefined,
  });
}
